import { useCallback, useMemo, useState } from "react";

import type { IUserKeywordGroup } from "app/services/keyword-groups";

export interface IOpenKeywordsGroupEditorSession {
    keywordsGroup?: IUserKeywordGroup;
    seedKeyword?: string;
}

export interface IKeywordsGroupEditorController {
    isOpen: boolean;
    session: IOpenKeywordsGroupEditorSession;
    sessionKey: number;
    hide: () => void;
    openSession: (session?: IOpenKeywordsGroupEditorSession) => void;
    show: () => void;
}

export const useKeywordsGroupEditorController = (
    initialSession: IOpenKeywordsGroupEditorSession = {},
): IKeywordsGroupEditorController => {
    const [isOpen, setIsOpen] = useState(false);
    const [session, setSession] = useState<IOpenKeywordsGroupEditorSession>(initialSession);
    const [sessionKey, setSessionKey] = useState(0);

    const show = useCallback(() => {
        setIsOpen(true);
    }, []);

    const hide = useCallback(() => {
        setIsOpen(false);
    }, []);

    const openSession = useCallback((nextSession: IOpenKeywordsGroupEditorSession = {}) => {
        setSession(nextSession);
        setSessionKey((currentSessionKey) => currentSessionKey + 1);
        setIsOpen(true);
    }, []);

    return useMemo(
        () => ({ isOpen, session, sessionKey, hide, openSession, show }),
        [hide, isOpen, openSession, session, sessionKey, show],
    );
};
